<template>
  <div style="min-width:1290px;">
    <MyBanner />
    <div>
      <div class="w1200">
        <div style="padding:20px 0;">
          <el-breadcrumb :separator-icon="ArrowRight">
            <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{Factive}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content">
          <div class="tabs">
            <!-- <div class="morebtn-line">更多 ></div> -->
            <el-tabs v-model="activeName" type="card" class="demo-tabs" @tab-click="changeTab">
              <el-tab-pane label="采购公告" name="first">
                <div class="tabs-content" v-for="(item,index) in EngineeringAnnouncements" :key="index" @click="goDetail(item.id,item.state)">
                  <div :class="checkRegistrationStatus(item.endTime) == '正在报名'?'tabs-status':'tabs-end'">
                    【{{checkRegistrationStatus(item.endTime)}}】</div>
                  <div class="tabs-mycontent">{{item.name}}</div>
                  <div class="tabs-time">{{ item.endTime.slice(0,11) }}</div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="变更公告" name="second">
                <div class="tabs-content" v-for="(item,index) in EngineeringAnnouncements" :key="index" @click="goDetail(item.id,item.state)">
                  <div class="tabs-mycontent">{{item.name}}</div>
                  <div class="tabs-time">{{ item.endTime.slice(0,11) }}</div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="中标候选人公示" name="third">
                <div class="tabs-content" v-for="(item,index) in EngineeringAnnouncements" :key="index" @click="goDetail(item.id)">
                  <div class="tabs-mycontent">{{item.name}}</div>
                  <div class="tabs-time">{{ item.endTime.slice(0,11) }}</div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="中标结果公告" name="fourth">
                <div class="tabs-content" v-for="(item,index) in EngineeringAnnouncements" :key="index" @click="goDetail(item.id)">
                  <div class="tabs-mycontent">{{item.name}}</div>
                  <div class="tabs-time">{{ item.endTime.slice(0,11) }}</div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="其他公告" name="fiveth">
                <div class="tabs-content" v-for="(item,index) in EngineeringAnnouncements" :key="index" @click="goDetail(item.id)">
                  <div class="tabs-mycontent">{{item.name}}</div>
                  <div class="tabs-time" v-if="item.endTime&&item.endTime!=''">{{ item.endTime.slice(0,11) }}</div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="box-content">
            <!-- <div class="box-content-item" v-for="item in PlatformDynamics" :key="item.id"
              @click="goDetail(item.id,0,changeName(Factive))">
              <div class="item-title" :title="item.title">{{item.title}}</div>
              <div class="item-time" v-if="item.updateTime&&item.updateTime!=''">{{item.updateTime.slice(5,11)}}</div>
            </div> -->
            <div style="display: flex;justify-content: flex-end;padding: 20px 10px 0px 20px;">
              <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 40]" :size="size" :disabled="disabled" background layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="outerVisible">
      <div class="content" style="max-height: 230px;overflow: hidden;">
        <div class="content-tip">
          <div class="bt">{{mesageData.name}}</div>
          <div class="announcement-flex">
            <div class="flex">
              <div class="title-box">项目类别：</div>
              <div class="content-box">{{TypeX(mesageData.tradeClassification)}}</div>
            </div>
            <!-- <div class="flex">
                <div class="title-box">报价截止时间：</div>
                <div class="content-box">{{mesageData.endTime}}</div>
              </div> -->
            <div class="flex">
              <div class="title-box">发布时间：</div>
              <div class="content-box">{{mesageData.publishTime}}</div>
              <div class="title-box" style="margin-left:20px;">查看次数：</div>
              <div class="content-box">{{1+Number(mesageData.viewNum)||1}}</div>
            </div>
          </div>
        </div>
        <!-- <div style="font-size: 14px;color: rgb(10, 96, 234);text-align: left;margin-top: 20px;margin-bottom: 10px;">
            详情介绍：</div> -->
        <div class="content-message" v-html="mesageData.content" v-if="mesageData.content != ''"></div>
      </div>
      <div class="ccl">
        <div class="tip-info">该项目仅限【{{mesageData.typeName}}】类型的入库供应商查看报名,如需继续查看报名,请登录系统</div>
        <div class="icon">
          <el-icon>
            <ArrowDown />
          </el-icon>
        </div>
        <div class="login-btn" @click="gysLogin()">
          <img src="./../static/供应商.png" alt="" srcset=""> <span>供应商登录入口</span>
        </div>
      </div>
    </el-dialog>
    <MyFooter />
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import MyBanner from "@/components/MyBanner.vue";
import MyFooter from "@/components/MyFooter.vue";
import { ArrowRight } from '@element-plus/icons-vue'
import { useRouter } from "vue-router";
import { getAllNavList, getAllNav, getNewsTable, getAllNotice, getTableList, getNoticeById } from "@/api/index.js"
const router = useRouter();
let Factive = ref(0)
let type = ref('A')
let outerVisible = ref(false);
let EngineeringAnnouncements = ref([]);
let activeName = ref('first')
let mesageData = ref({})
let detailData = async (id) => {
  await getNoticeById({ id: id }).then(res => {
    mesageData.value = res.data
  })
}
let checkRegistrationStatus = (endTimeStr) => {
  const endTime = new Date(endTimeStr);
  const currentTime = new Date();
  if (endTime > currentTime) {
    return "正在报名";
  } else {
    return "报名结束";
  }
}
let TypeX = (value) => {
  if (value == "A") {
    return '工程'
  } else if (value == "B") {
    return '货物'
  } else if (value == "C") {
    return '服务'
  }
}
let information = ref([
  { id: 0, title: '招标公告', type: 'tender_bulletin' },
  { id: 1, title: '变更公告', type: 'correctional_bulletin' },
  { id: 2, title: '中标候选人公示', type: 'win_candidate_publicity' },
  { id: 3, title: '中标结果公告', type: 'win_notice' },
  { id: 4, title: '其他公告', type: 'failed_notice' }
])
let Stype = ref('tender_bulletin')
let currentPage = ref(1)
let pageSize = ref(10)
let disabled = ref(false)
let size = ref('default')
let ztbUrl = ref("");
let total = ref()
let changeTab = (tab) => {
  currentPage.value = 1
  information.value.forEach(item => {
    if (item.id == tab.index) {
      Stype.value = item.type
      getList()
    }
  })
}


let goDetail = (id, state) => {
  if (state == 2) {
    outerVisible.value = true
    detailData(id)
  } else {
    router.push({ path: '/platformAnnouncementsDetail', query: { ids: id, title: Factive.value } })
  }
}

let gysLogin = () => {
  window.open(ztbUrl.value + '?jumpSys=3&jumpId=' + mesageData.value.tenderBulletinId, '_blank')
}

let getList = async () => {
  if (type.value == "A") {
    await getTableList({ current: currentPage.value, size: pageSize.value, type: Stype.value, tradeClassification: type.value, name: '', ascs: '', descs: '' }).then(res => {
      EngineeringAnnouncements.value = res.data.records
      total.value = res.data.total
    })
  }
  if (type.value == "B") {
    await getTableList({ current: currentPage.value, size: pageSize.value, type: Stype.value, tradeClassification: type.value, name: '', ascs: '', descs: '' }).then(res => {
      EngineeringAnnouncements.value = res.data.records
      total.value = res.data.total
    })
  }
  if (type.value == "C") {
    await getTableList({ current: currentPage.value, size: pageSize.value, type: Stype.value, tradeClassification: type.value, name: '', ascs: '', descs: '' }).then(res => {
      EngineeringAnnouncements.value = res.data.records
      total.value = res.data.total
    })
  }
}


let handleSizeChange = (val) => {
  pageSize.value = val
  getList()
}
let handleCurrentChange = (val) => {
  currentPage.value = val
  getList()
}

onMounted(async () => {
  await getAllNavList().then(res => {
    res.data.forEach(ele => {
      if(ele.id == '1809108066738638849'){
        ztbUrl.value = ele.link
      }
    })
  })
  Factive.value = router.currentRoute.value.query.str ? router.currentRoute.value.query.str : router.currentRoute.value.query.title
  type.value = router.currentRoute.value.query.type ? router.currentRoute.value.query.type : ''
  getList()
});
</script>
<style scoped>
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
::v-deep .el-tabs {
  background: rgb(248, 248, 248);
}
::v-deep .el-carousel__indicators--horizontal {
  left: 78%;
  bottom: -2px;
  transform: translateX(0);
}
::v-deep .el-tabs__item.is-active {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(219, 36, 28, 1) 0%,
    rgba(235, 132, 39, 1) 100%
  );
  position: relative;
}
.w1200 {
  width: 1300px;
  margin: 0 auto;
}
.content {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  padding: 20px;
  margin-bottom: 20px;
}
.box-content {
  height: calc(100% - 70px);
  padding: 20px;
  box-sizing: border-box;
}
.box-content-item {
  height: 24px;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-bottom: 27px;
  cursor: pointer;
}
.box-content-item:nth-last-child(1) {
  margin-bottom: 0;
}
.box-content-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #999999;
}
.item-title {
  width: 80%;
  font-size: 16px;
  font-weight: 400;
  color: #444;
  margin-left: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-time {
  width: 19%;
  text-align: right;
  font-size: 14px;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
}
.tabs-content {
  padding: 15px 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.1s;
  color: rgba(0, 0, 0, 1);
  background: #fff;
}
.tabs-content:nth-child(2n) {
  background: rgb(245, 247, 250);
}
.tabs-content:hover {
  color: rgba(219, 36, 28, 1);
  border-left: 4px solid rgba(219, 36, 28, 1);
}
.tabs {
  position: relative;
  margin-top: 27px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 237, 242, 1);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.12);
}
.tabs-status {
  font-size: 16px;
  font-weight: 400;
  color: rgba(67, 207, 124, 1);
}
.tabs-end {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 0, 0, 1);
}
.tabs-mycontent {
  width: 69%;
  margin-right: auto;
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tabs-time {
  font-size: 14px;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
}
.content {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  padding: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}
.content-tip {
  border-radius: 5px;
  padding: 20px;
}
.title-box {
  font-size: 14px;
  font-weight: 400;
  color: #bbbbb3 !important;
}
.content-box {
  font-size: 14px;
  font-weight: 400;
  color: #bbbbb3 !important;
}
.flex {
  display: flex;
  align-items: center;
  margin-right: 12px;
}
.announcement-flex {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.bt {
  font-size: 24px;
  font-weight: 600;
  color: #444;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e0e0;
  text-align: center;
}
.login-btn {
  background: #ebf4fa;
  border-radius: 8px;
  width: 50%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 117, 194, 1);
  cursor: pointer;
  margin-top: 10px;
}
.login-btn img {
  width: 26px;
  height: 26px;
  margin-right: 10px;
}
.ccl {
  width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  position: relative;
}
</style>